"use client";
import React from "react";

import Header from "./../components/Header";
import Pricing from "./../components/Pricing";

const FAQPage = () => {
  return (
    <>
      <Header />
      <main data-router-wrapper>
        <section className="js-page page home " data-router-view="home">
          <section className="faq clear-selection js-anchor is-anchor-set" data-main-section="" id="faq" data-slug="faq">
            <div className="content">
              <h2 className="section-title">Frequently Asked Questions</h2>
              <div className="columns">
                <div className="column">
                  <div className="item">
                    <div className="question">What are the prerequisites?</div>
                    <div className="answer">
                      <p>Even if the course is beginner friendly, you need to know JavaScript basics like variables, objects, arrays, loops, functions, conditions and events.</p>
                      <p>The code editor used in the lessons is Visual Studio Code but you can use any editor you like.</p>
                      <p>The browser used in the lessons is Chrome but you can use any browser you like. However, it is recommended to use one with a good developer tools panel like Chrome or Firefox.</p>
                      <p>Eventually, you will have to install Blender, but the software is free and works on all major OS.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Can I use Three.js with React?</div>
                    <div className="answer">
                      <p>Yes, thanks to the <a href="https://docs.pmnd.rs/react-three-fiber/getting-started/introduction" target="_blank">React Three Fiber</a> renderer, we can write Three.js application directly in React.</p>
                      <p>And it doesn't stop there. React Three is a huge ecosystem with many tools and features that will improve your developer's life.</p>
                      <p>It's so big that a whole chapter is dedicated to the topic.</p>
                      <p>And if you don't know React, the course includes a 4 hours long lesson that will teach you the basics of React.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Is the content up to date?</div>
                    <div className="answer">
                      <p>All the dependencies used throughout the lessons are updated multiple times a year and the content is adjusted accordingly.</p>
                      <p>New lessons are also regularly added in order to cope with the latest features and to answer community requests.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">What if I need help?</div>
                    <div className="answer">
                      <p>With the course, you will also get access to a <a href="https://threejs-journey.com/discord" data-router-disabled="">private Discord</a> server. If you get stuck or you don't understand a specific part of a lesson, you can share your problem to get help.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">I don't speak English very well. Will it be a problem?</div>
                    <div className="answer">
                      <p>Although the lessons are in English, they have all been <strong>captioned</strong>.<br />For a better comprehension, the technical terms are perfectly written and highlighted.<br />And if the video is going too fast, you can slow down the pace.</p>
                      <p>French, Spanish, and Hindi subtitles are available as well.</p>
                      <p>To test and see how difficult it is for you to follow, all beginnings and some full lessons are available for free.</p>
                      <p>Finally, all the lessons are available as text right below the video with the exact same content (screenshots, code snippets, video previews, etc.)</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Can I offer it?</div>
                    <div className="answer">
                      <p>Yes, you can gift the course to someone else by clicking on <a href="https://threejs-journey.com/gift" data-router-disabled="" className="gift">this link</a>.</p>
                      <p>You can pick an option between letting us email the gift to the receiver or you can share the gift yourself.</p>
                      <p>You'll receive an invoice by email and the recipient won't have access to your billing information.</p>
                    </div>
                  </div>
                </div>
                <div className="column">
                  <div className="item">
                    <div className="question">Can I test the lessons?</div>
                    <div className="answer">
                      <p>The first lessons are free! Have a look and see for yourself if you like the content.</p>
                      <p>And if it's not enough, the beginning of every other lesson is also free.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">What if I don't like the course?</div>
                    <div className="answer">
                      <p>If you are not happy with the course, whatever the reason is, you can ask for a refund at any time by sending an email at <a href="mailto:contact@threejs-journey.com" target="_blank">contact@threejs-journey.com</a>.</p>
                      <p>Following the refund, your account will be deleted.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Is there a way to get a discount?</div>
                    <div className="answer">
                      <p>The price of the course has already been calculated to be as low as possible in order to be accessible for everyone and the VAT is included.</p>
                      <p>You pay only once and get access to all the lessons, a members-only Discord server and upcoming updates!</p>
                      <p>Still, if it's too expensive for you, discounts might happen at some occasions. Follow <a href="https://twitter.com/bruno_simon" target="_blank">@bruno_simon</a> on Twitter to be alerted.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Do I have to do the entire course to start my own project?</div>
                    <div className="answer">
                      <p>No! Once you feel comfortable, you can start working on your personal experiences by yourself. You won't have to wait until the end of the course, but obviously, you will be able to jump back to the course at any time where you left it.</p>
                      <p>And if you struggle on any project, whether it is personal or professional, the Three.js Journey community will always be happy to help.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Do you provide a certificate of completion?</div>
                    <div className="answer">
                      <p>Yes! Each lesson comes with a quiz. Completing all quizzes will grant you access to a public certificate that you can print or share with the world.</p>
                      <p>Failing on answering a quiz will result in a few minutes time out, letting you time to find the information before answering again.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Can I ask for a VAT refund?</div>
                    <div className="answer">
                      <p>If your company is in the EU (outside of France), you can ask for a VAT refund.</p>
                      <p>To do that, after buying the course, go to your account settings and fill the VAT refund request form. Information will be reviewed and proof that you work at the company might be requested.</p>
                    </div>
                  </div>
                  <div className="item">
                    <div className="question">Can I have an invoice?</div>
                    <div className="answer">
                      <p>Once you've bought the course, you get access to an invoice. You can add any additional data you need on the document.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>

      </main>
    </>
  );
};

export default FAQPage;
